import styled from 'styled-components';

export const UsersHint = styled.p`
  margin: 10px 0;
`;

export const LoadedPersonsMessage = styled.p`
  margin: 10px 0;
`;
